import { render, staticRenderFns } from "./IndexFour.vue?vue&type=template&id=31b0d612&"
import script from "./IndexFour.vue?vue&type=script&lang=js&"
export * from "./IndexFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports